<template>
  <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <!-- Search container -->
        <!-- <div class="box box-success">
          <div class="box-header with-border">
            <h3 class="box-title">{{ $t("search.title") }}</h3>
          </div>
          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-3 col-md-3 col-lg-3">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('search.title')"
                  v-model="search.searchText"
                />
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <button
                  type="button"
                  class="btn btn-labeled btn-success"
                  @click="onSearchCase"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{ $t("search.search_button") }}
                </button>
              </div>
            </div>
          </div>
        </div> -->
        <!--  -->
        <div class="box box-primary">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b>{{ $t("configuration.apartmentTypePrice.apartmentTypePriceList") }}</b>
              <lte-button
                style="float:right"
                type="btn btn-primary"
                right_icon="fa fa-plus"
                @click="addNew($event)"
                >{{ $t("common.addnew") }}</lte-button
              >
              <lte-button
                style="float:right; marign-right: 15px; background-color: #f29911;border-color: #f29911;"
                type="btn btn-warning"
                right_icon="fa fa-mail-reply"
                @click="onCallBack($event)"
                >{{ $t("common.back") }}</lte-button
              >
            </div>
          </div>
          <div class="box-body">
            <!-- B-Table Start -->
            <b-table
              :items="gridDataList"
              :fields="gridColumns"
              class="mt-3"
              outlined
              responsive
            >
              <template #head()="scope">
                <div>{{ $t(scope.label) }}</div>
              </template>
              <template #cell(priceType)="row">
                {{ $t(getapartmentTypePriceTypeName(row.item.priceType)) }}
              </template>
              <template #cell(actions)="row">
                <div class="btn-group">
                  <button
                    v-if="!row.item.enable"
                    class="btn btn-success btn-sm"
                    style="margin-left: 6px;"
                    @click="onClickEnable(row.item.id)"
                  >
                    <i class="glyphicon glyphicon-ok"></i>
                  </button>
                  <button
                    class="btn btn-primary btn-sm"
                    style="margin-left: 6px;"
                    @click="onOpenEditInput(row.item)"
                  >
                    <i class="glyphicon glyphicon-edit"></i>
                  </button>
                  <button
                    class="btn btn-danger btn-sm"
                    style="margin-left: 6px;"
                    @click="onOpenDelete(row.item)"
                  >
                    <i class="glyphicon glyphicon-trash"></i>
                  </button>
                </div>
              </template>
            </b-table>
            <!-- B-Table End -->
          </div>
        </div>
        <!--  -->
        <div class="box-footer clearfix" style="display:contents;">
          <paginator
            :totalItem="paginateData.totalItem"
            :currentPage="paginateData.currentPage"
            :pageSize="paginateData.pageSize"
            :totalPage="paginateData.totalPage"
            @onpaginate="onPagination"
          />
        </div>
      </row>
    </div>
    <!--  -->
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <!--  -->
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <!--  -->
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirm"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
  </div>
</template>
<script>
import Paginator from "@/components/CustomPaginator.vue";
import { mapGetters, mapActions } from "vuex";
import LTEButton from "@/components/LTEButton.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import LTEModal from "@/components/LTEModal.vue";

import utils from "@/lib/utils";
import constantsData from "@/lib/constantsData";
// import moment from "moment";
import Loading from "vue-loading-overlay";

export default {
  name: "CaseList",
  data() {
    return {
      apartmentTypeId: 0,
      gridDataList: [],
      gridColumns: [
        {
          label: "common.nonumber",
          key: "nonumber",
          class: "text-center "
        },
        {
          label: "apartmentType.apartmentTypeName",
          key: "apartmentTypeName",
          class: "text-center "
        },
        {
          label: "configuration.apartmentTypePrice.priceName",
          key: "priceName",
          class: "text-center "
        },
        {
          label: "configuration.apartmentTypePrice.dayUnitPrice",
          key: "dayUnitPrice",
          class: "text-center "
        },
        {
          label: "configuration.apartmentTypePrice.priceType",
          key: "priceType",
          class: "text-center "
        },
        { key: "actions", label: "common.action" }
      ],
      originalRecordData: [],
      isModalVisible: false,
      objModal: [
        {
          title: "common.delete_modal.title",
          body: "common.delete_modal.content",
          buttonNo: "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ],
      search: {
        searchText: ""
      },
      isLoading: false,
      paginateData: {
        totalItem: 1,
        currentPage: 1,
        pageSize: 1,
        totalPage: 1
      },
      apartmentTypePriceTypeList: constantsData.apartmentTypePriceTypeList
    };
  },
  watch: {
    GET_LANG: function() {
      this.getApartmentTypePriceList(this.paginateData.currentPage);
    },
    GET_APARTMENT_TYPE_PRICE_LIST_DATA: function() {
      let paginate = this.GET_APARTMENT_TYPE_PRICE_LIST_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      this.gridDataList = [];
      let data = this.GET_APARTMENT_TYPE_PRICE_LIST_DATA.results;
      data.forEach((element, i) => {
        let id = element.id;
        let nonumber = i + 1 + (paginate.currentPage - 1) * paginate.pageSize;

        let data = {
          id: id,
          nonumber: nonumber,
          apartmentTypeName: element.apartment_type,
          priceName: element.price_name,
          dayUnitPrice: element.day_unit_price,
          priceType: element.price_type,
          enable: element.enable
        };
        this.gridDataList.push(data);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA",
      "GET_APARTMENT_TYPE_PRICE_LIST_DATA",
      "GET_LANG"
    ])
  },

  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onShowError: function(mess) {
      this.ON_SHOW_TOAST({
        message: mess,
        styleType: "danger"
      });
    },
    onCallBack: function() {
      window.history.back();
    },
    getapartmentTypePriceTypeName: function(value) {
      let index = this.apartmentTypePriceTypeList.findIndex(
        x => x.value === value
      );
      return index !== -1 ? this.apartmentTypePriceTypeList[index].text : null;
    },
    getSearchData: function(data) {
      this.search.searchText = data;
      this.getApartmentTypePriceList(1);
    },
    onSearchCase: function() {
      this.getApartmentTypePriceList(1);
    },
    addNew: function() {
      this.$router.push({
        name: "ApartmentTypePriceAdd",
        params: {
          apartmentTypeId: this.apartmentTypeId,
          id: 0
        }
      });
    },
    onOpenEditInput: function(row) {
      this.$router.push({
        name: "ApartmentTypePriceAdd",
        params: {
          apartmentTypeId: this.apartmentTypeId,
          id: row.id
        }
      });
    },
    onPagination: function(data) {
      this.GET_APARTMENT_TYPE_PRICE_LIST(data);
    },
    getApartmentTypePriceList: function(page) {
      this.isLoading = true;
      let filter = {
        params: {
          page: page,
          searchText: this.search.searchText,
          apartmentTypeId: this.apartmentTypeId
        }
      };
      this.GET_APARTMENT_TYPE_PRICE_LIST(filter)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    onClickEnable: function(id) {
      let data = {
        id: id,
        isEnable: true
      };
      this.UPDATE_APARTMENT_TYPE_PRICE(data)
        .then(
          function() {
            this.getApartmentTypePriceList(this.paginateData.currentPage);
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    onOpenDelete: function(row) {
      this.originalRecordData = row;
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onConfirm: function() {
      this.CANCEL_APARTMENT_TYPE_PRICE(this.originalRecordData)
        .then(
          function() {
            this.isModalVisible = false;
            this.getApartmentTypePriceList(this.paginateData.currentPage);
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function(error) {
            if (error.response.data.errorText !== undefined) {
              this.onShowError(error.response.data.errorText);
            } else if (error.response.data.message !== undefined) {
              this.onShowError(error.response.data.message);
            } else {
              this.ERROR_TOAST();
            }
          }.bind(this)
        );
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_APARTMENT_TYPE_PRICE_LIST",
      "UPDATE_APARTMENT_TYPE_PRICE",
      "CANCEL_APARTMENT_TYPE_PRICE"
    ])
  },
  mounted() {
    let apartmentTypeId = this.$route.params.apartmentTypeId;
    this.apartmentTypeId = apartmentTypeId;
    this.getApartmentTypePriceList(1);
  },

  components: {
    "lte-button": LTEButton,
    "lte-core-alert": LTECoreAlert,
    "lte-modal": LTEModal,
    paginator: Paginator,
    loading: Loading
  }
};
</script>
<style scoped>
label.required:after {
  content: " *";
  color: red;
  position: absolute;
  padding-left: 8px;
  top: -5px;
}
</style>



// WEBPACK FOOTER //
// src/views/Configuration/ApartmentType/ApartmentTypePrice.vue